module.exports = __webpack_public_path__ + "img/minting-shape4.2af94ee9.png";